import { EGestaoTarefasEtapa } from '@/utils/helpers/enums/gestao-tarefas/GestaTarefasEtapas';

export default {
  getDraggedItem(state) {
    return state.draggedItem;
  },
  getListaResponsaveis(state) {
    return state.listaResponsaveis;
  },
  getHeadersProdutoTable(state) {
    return state.headersProdutoNCM;
  },
  getCardsGestaoTarefas(state) {
    return state.cards;
  },
  getResponsaveisTrust(state) {
    return state.responsaveisTrust;
  },
  getResponsaveisComex(state) {
    return state.responsaveisComex;
  },
  getCardSelecionado(state) {
    return state.cardSelecionado;
  },
  getAtividades(state) {
    return state.atividades;
  },
  getAtividadesCardSelecionado(state) {
    const etapaCard = state.cardSelecionado.posicaoCard;
    if (etapaCard?.toLowerCase() === EGestaoTarefasEtapa.PENDENTE || !etapaCard) {
      return [];
    }
    return state.cardSelecionado.checklist[`${etapaCard.toLowerCase()}`];
  },
  getEtapaCardSelecionado(state) {
    const etapaCard = state.cardSelecionado.posicaoCard;
    if (!etapaCard) {
      return '';
    }
    return etapaCard.toLowerCase();
  },
  getPosicaoCardSelecionado(state) {
    return state.cardSelecionado.posicaoCard?.toLowerCase();
  },
  getIdCardReferencia(state) {
    return state.cardSelecionado?.idCard;
  },
  getCodigoReferenciaInternaCardSelecionado(state) {
    return state.cardSelecionado.informacoesGerais?.referenciaInterna || '';
  },
  getListaCardsAcompanhamento(state) {
    return state.cards.filter((card) => card.posicaoCard === EGestaoTarefasEtapa.ACOMPANHAMENTO.toUpperCase() && card.ativo && card.idCard);
  },
  getListaCardsRegulatorioNovoProduto(state) {
    return state.cards.filter((card) => card.posicaoCard === EGestaoTarefasEtapa.REGULATORIOCADASTRONOVOPRODUTO.toUpperCase() && card.ativo && card.idCard);
  },
  getMostrarConcluidos(state) {
    return state.mostrarConcluidos;
  },
};
